/**
 * Created by fworld on 2019/12/26.
 */
import request from '@/util/request'

export function distributeIm(params) {
    return request({
        url: '/api/v1/delivery/distribute/im',
        method: 'get',
        params
    })
}
